"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.split.js");
var _default = postal => {
  const resolver = {
    cache: {},
    regex: {},
    enableCache: true,
    compare: function compare(binding, topic, headerOptions) {
      var pattern;
      var rgx;
      var prevSegment;
      var cacheKey = topic + postal.configuration.cacheKeyDelimiter + binding;
      var result = this.cache[cacheKey];
      var opt = headerOptions || {};
      var saveToCache = this.enableCache && !opt.resolverNoCache;
      // result is cached?
      if (result === true) {
        return result;
      }
      // plain string matching?
      if (binding.indexOf("#") === -1 && binding.indexOf("*") === -1) {
        result = topic === binding;
        if (saveToCache) {
          this.cache[cacheKey] = result;
        }
        return result;
      }
      // ah, regex matching, then
      if (!(rgx = this.regex[binding])) {
        pattern = "^" + binding.split(".").map(function mapTopicBinding(segment) {
          var res = "";
          if (!!prevSegment) {
            res = prevSegment !== "#" ? "\\.\\b" : "\\b";
          }
          if (segment === "#") {
            res += "[\\s\\S]*";
          } else if (segment === "*") {
            res += "[^.]+";
          } else {
            res += segment;
          }
          prevSegment = segment;
          return res;
        }).join("") + "$";
        rgx = this.regex[binding] = new RegExp(pattern);
      }
      result = rgx.test(topic);
      if (saveToCache) {
        this.cache[cacheKey] = result;
      }
      return result;
    },
    reset: function reset() {
      this.cache = {};
      this.regex = {};
    },
    purge: function purge(options) {
      var self = this;
      var keyDelimiter = postal.configuration.cacheKeyDelimiter;
      var matchPredicate = function matchPredicate(key) {
        var split = key.split(keyDelimiter);
        var topic = split[0];
        var binding = split[1];
        if ((typeof options.topic === "undefined" || options.topic === topic) && (typeof options.binding === "undefined" || options.binding === binding)) {
          delete self.cache[key];
        }
      };
      var compactPredicate = function compactPredicate(key) {
        var split = key.split(keyDelimiter);
        if (postal.getSubscribersFor({
          topic: split[0]
        }).length === 0) {
          delete self.cache[key];
        }
      };
      if (typeof options === "undefined") {
        this.reset();
      } else {
        var handler = options.compact === true ? compactPredicate : matchPredicate;
        Object.keys(this.cache).forEach(handler);
      }
    }
  };
  return resolver;
};
exports.default = _default;